/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   ____  ____   ___  
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| |  _ \|  _ \ / _ \ 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || |  | |_) | |_) | | | |
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |  |  __/|  _ <| |_| |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___| |_|   |_| \_\\___/ 
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.horizon-ui.com/pro/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React from 'react';
import { NavLink } from 'react-router-dom';
// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
  keyframes,
} from '@chakra-ui/react';
// Custom components
import { HSeparator } from 'components/separator/Separator';
import DefaultAuth from 'layouts/auth/variants/Default';
// Assets
import illustration from 'assets/img/auth/auth.png';
import { FcGoogle } from 'react-icons/fc';
import { MdOutlineRemoveRedEye, MdOutlineNewReleases, MdOutlineSupportAgent } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import AuthApi from 'api/auth';
import { useAuth } from 'contexts/auth.context';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';


const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50%       { transform: translateY(-3px); }
`;

const glow = keyframes`
  0%, 100% { box-shadow: 0 0 0px 0px rgba(99,179,237,0); }
  50%       { box-shadow: 0 0 8px 3px rgba(99,179,237,0.45); }
`;

function SignIn() {
  // Chakra color mode
  const toast = useToast();
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const textColorDetails = useColorModeValue('navy.700', 'secondaryGray.600');
  const textColorBrand = useColorModeValue('brand.500', 'white');
  const textColorError = useColorModeValue('red.500', 'red');
  const brandStars = useColorModeValue('brand.500', 'brand.400');
  const googleBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.200');
  const googleText = useColorModeValue('navy.700', 'white');
  const googleHover = useColorModeValue(
    { bg: 'gray.200' },
    { bg: 'whiteAlpha.300' },
  );
  const googleActive = useColorModeValue(
    { bg: 'secondaryGray.300' },
    { bg: 'whiteAlpha.200' },
  );
  const [show, setShow] = React.useState(false);
  const [formData, setFormData] = React.useState({
    email: "", // DEFAULT Auth HERE (email) 
    password: ""  // DEFAULT Auth HERE (password)                              
  });
  const [error, setError] = React.useState('');

  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const handleClick = () => setShow(!show);

  const handleChange = (event: any) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleLogin = (event: any) => {
    console.log('formData', formData);
    event.preventDefault();
    AuthApi.Login(formData)
      .then((response: any) => {
        toast({
          title: 'Usuario correcto',
          description: 'Inicio de sesión exitoso.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        console.log('response', response);

        sessionStorage.removeItem('user');
        sessionStorage.removeItem('hotelSeleccionado');

        //se guarda en sessionStorage el usuario y su información (es un json)
        sessionStorage.setItem('user', JSON.stringify(response.data.dataDB));

        navigate('/admin/dashboards');
        if (response.data.success) {
          setProfile('Bienvenido ')

        } else {
          setError(response.data.msg);
        }
        console.log(formData.email)


      })
      .catch((error: any) => {
        if (error.response) {
          setError(error.response.data.msg);
        }
        setError('Usuario o contraseña incorrectos');
      });
  };

  const setProfile = (response: any) => {
    let user = { ...response.data.user };
    user.token = response.data.token;
    user = JSON.stringify(user);
    setUser(user);
    localStorage.setItem('user', user);
    navigate('/admin/dashboards/default');
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: '100%', md: 'max-content' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: '30px', md: '60px' }}
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '40px', md: '14vh' }}
        flexDirection="column"
      >

        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px">
            Iniciar Sesión
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Sistema de Gestión de Activos
          </Text>
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: '100%', md: '420px' }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: 'auto', lg: 'unset' }}
          me="auto"
          mb={{ base: '20px', md: 'auto' }}
        >
          {/* <Button
              fontSize="sm"
              me="0px"
              mb="26px"
              py="15px"
              h="50px"
              borderRadius="16px"
              bg={googleBg}
              color={googleText}
              fontWeight="500"
              _hover={googleHover}
              _active={googleActive}
              _focus={googleActive} 
            >
              <Icon as={FcGoogle} w="20px" h="20px" me="10px" />
              Sign in with Google
            </Button> */}
          {/* <Flex align="center" mb="25px">
              <HSeparator />
              <Text color="gray.400" mx="14px">
                or
              </Text>
              <HSeparator />
            </Flex> */}
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Correo Electrónico<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired={true}
              variant="auth"
              fontSize="sm"
              ms={{ base: '0px', md: '0px' }}
              type="email"
              placeholder="ejemplo@velasresorts.com"
              mb="24px"
              fontWeight="500"
              size="lg"
              name="email"
              onChange={handleChange}
              defaultValue={formData.email}
            />
            <FormLabel
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              display="flex"
            >
              Contraseña<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size="md">
              <Input
                isRequired={true}
                fontSize="sm"
                placeholder="Min. 8 characters"
                mb="24px"
                size="lg"
                type={show ? 'text' : 'password'}
                variant="auth"
                name="password"
                onChange={handleChange}
                defaultValue={formData.password}
              />
              <InputRightElement display="flex" alignItems="center" mt="4px">
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: 'pointer' }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                />
              </InputRightElement>
            </InputGroup>
            <Flex justifyContent="space-between" align="center" mb="24px">
              <FormControl display="flex" alignItems="center">
                <Checkbox
                  id="remember-login"
                  colorScheme="brandScheme"
                  me="10px"
                />
                <FormLabel
                  htmlFor="remember-login"
                  mb="0"
                  fontWeight="normal"
                  color={textColor}
                  fontSize="sm"
                >
                  Mantenerme conectado
                </FormLabel>
              </FormControl>
              <NavLink to="/auth/forgot-password/default">
                <Text color={textColorBrand} fontSize="sm" fontWeight="500">
                  ¿Olvidaste tu contraseña?
                </Text>
              </NavLink>
            </Flex>
            <Flex justifyContent="center" align="center" mb="24px">
              <Text
                color={textColorError}
                fontSize="sm"
                w="214px"
                fontWeight="500"
              >
                {error}

              </Text>
            </Flex>
            <Button
              fontSize="sm"
              onClick={handleLogin}
              variant="brand"
              fontWeight="500"
              w="100%"
              h="50"
              mb="12px"
            >
              Iniciar Sesión
            </Button>
            <Button
              as="a"
              href="https://inventarios.velasresorts.com/changelog"
              target="_blank"
              rel="noopener noreferrer"
              fontSize="sm"
              fontWeight="500"
              w="100%"
              h="44px"
              mb="24px"
              variant="outline"
              colorScheme="brand"
              animation={`${glow} 2.4s ease-in-out infinite`}
              transition="all 0.25s ease"
              _hover={{ transform: 'translateY(-2px)', boxShadow: '0 4px 14px rgba(99,179,237,0.5)' }}
              _active={{ transform: 'translateY(0px)' }}
              leftIcon={
                <Icon
                  as={MdOutlineNewReleases}
                  w="18px"
                  h="18px"
                  animation={`${float} 2.4s ease-in-out infinite`}
                />
              }
            >
              Ver novedades y actualizaciones
            </Button>
            <Button
              as="a"
              href="https://restapi.velasresorts.com/report-issue?project=inventarios"
              target="_blank"
              rel="noopener noreferrer"
              fontSize="sm"
              fontWeight="500"
              w="100%"
              h="44px"
              mb="24px"
              variant="outline"
              colorScheme="gray"
              leftIcon={<Icon as={MdOutlineSupportAgent} w="18px" h="18px" />}
            >
              Reportar un problema
            </Button>
          </FormControl>
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="start"
            maxW="100%"
            mt="0px"
          >
            <Text color={textColorDetails} fontWeight="400" fontSize="14px">
              No tienes una cuenta?
              <NavLink to="/auth/sign-up/default">
                <Text
                  color={textColorBrand}
                  as="span"
                  ms="5px"
                  fontWeight="500"
                >
                  Crear una cuenta
                </Text>
              </NavLink>
            </Text>
          </Flex>
        </Flex>

      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
